<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-1 flex justify-end">
          <q-checkbox outlined dense @click="onSelectChange(noticeTemplate)" v-model="noticeTemplate.selected" class="bg-white"/>
        </div>
        <div class="col-9 q-ml-md">
          <span class="text-black bold float-left checkbox-label">
            {{ $t('task.printDocument.filesName.'+ noticeTemplate.fileName) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {NoticeTemplate} from "@/types";
import store from "@/store";
import {Emit} from "vue-property-decorator";

@Options({
  props: ['noticeTemplate','notice']
})
export default class PrintDocumentListPackItem extends Vue {

  noticeTemplate?: NoticeTemplate
  notice: any

  get templates() {
    return store.state.printDocumentModule.templates
  }

  onSelectChange(noticeTemplate: any) {
    store.dispatch('printDocumentModule/setTemplateSelectedItem',
        { template: this.noticeTemplate, selected: this.noticeTemplate?.selected , parentNotice :this.notice })

    this.checkTemplatesItemsSelected()
  }

  @Emit('child-boolean-changed')
  checkTemplatesItemsSelected() {}

}
</script>

<style scoped>

</style>
